import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-264" data-mp="3fznsli0714zs">
      <div className="mx-auto max-w-6xl px-4" data-id="element-265" data-mp="3fxkxijk6olo7">
        <p className="text-center text-xs font-extrabold uppercase tracking-[.18em] text-teal" data-id="element-266" data-mp="3b1cjj9hq2yim">Lo que dicen los que ya lo tienen</p>
        <h2 id="reviews-title" className="mt-3 text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-267" data-mp="370aj4pc2kgf2">
          Astronomía con contexto argentino
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-268" data-mp="2x005x4q1b8zw">
          {reviews.map(([initials, name, role, quote, color], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-ivory flex min-h-[255px] flex-col rounded-2xl border border-line p-6 text-ink shadow-card" data-id="element-269" data-mp="2s3jh08b0gqlr" data-mpi={index}>
              <div className="flex text-gold" data-id="element-270" data-mp="m2opj48c0cq3">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" data-id="element-271" data-mp="c6v9vbzbg343" />)}
              </div>
              <blockquote className="mt-4 flex-1 text-sm italic leading-relaxed text-muted" data-id="element-272" data-mp="zvwe0n148s3k">“{quote}”</blockquote>
              <div className="mt-5 flex items-center gap-3 border-t border-line pt-4" data-id="element-273" data-mp="14vskqu176xmt">
                <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-extrabold text-white ${color}`} data-id="element-274" data-mp="q766kvnb4bx6">
                  {initials}
                </span>
                <span data-id="element-275" data-mp="1ius87ycz56he">
                  <b className="block text-sm text-ink" data-id="element-276" data-mp="1iu8yv61e3qez">{name}</b>
                  <small className="text-xs text-muted" data-id="element-277" data-mp="1nlqr95pckioc">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}